import { Component } from '@theme/component';

class SwfEventGalleryComponent extends Component {
  #urls = [];
  #index = 0;

  connectedCallback() {
    super.connectedCallback();
    const script = this.querySelector('script[data-event-gallery-urls]');
    if (!script) return;
    try { this.#urls = JSON.parse(script.textContent).filter(Boolean); } catch { return; }
    document.addEventListener('keydown', this.#onKey.bind(this));
  }

  openGallery(event) {
    const btn = event.target.closest('[data-index]');
    if (!btn || this.#urls.length === 0) return;
    this.#index = parseInt(btn.dataset.index, 10) || 0;
    this.#show();
  }

  closeGallery() {
    if (this.refs.lightbox) this.refs.lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  prevGalleryImage() {
    this.#index = (this.#index - 1 + this.#urls.length) % this.#urls.length;
    this.#updateImg();
  }

  nextGalleryImage() {
    this.#index = (this.#index + 1) % this.#urls.length;
    this.#updateImg();
  }

  #show() {
    if (!this.refs.lightbox) return;
    this.refs.lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    this.#updateImg();
  }

  #updateImg() {
    if (this.refs.galleryImg) this.refs.galleryImg.src = this.#urls[this.#index] || '';
    if (this.refs.galleryCounter) this.refs.galleryCounter.textContent = `${this.#index + 1} / ${this.#urls.length}`;
  }

  #onKey(e) {
    if (!this.refs.lightbox || this.refs.lightbox.hidden) return;
    if (e.key === 'Escape') this.closeGallery();
    if (e.key === 'ArrowLeft') this.prevGalleryImage();
    if (e.key === 'ArrowRight') this.nextGalleryImage();
  }
}

if (!customElements.get('swf-event-gallery-component')) {
  customElements.define('swf-event-gallery-component', SwfEventGalleryComponent);
}
